import React from 'react';
import { useGallery } from '../context/GalleryContext';
import Photo from './Photo';
import useInfiniteScroll from '../hooks/useInfiniteScroll';
import './Gallery.css';

const Gallery = () => {
  const {
    photos,
    loading,
    loadingMore,
    viewMode,
    loadMore
  } = useGallery();

  const { ref } = useInfiniteScroll(loadMore);

  if (loading && photos.length === 0) {
    return (
      <div className="gallery-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!loading && photos.length === 0) {
    return (
      <div className="gallery-empty">
        <h3>No photos found</h3>
        <p>Try adjusting your search or check back later.</p>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <div className={`gallery ${viewMode}`}>
        {photos.map((photo, index) => (
          <Photo key={`${photo.id}-${index}`} {...photo} />
        ))}
      </div>

      <div ref={ref} className="loading-trigger">
        {loadingMore && (
          <div className="spinner-small"></div>
        )}
      </div>
    </div>
  );
};

export default Gallery; 